















































































import Vue from 'vue'
import Presenter, { IPresenter } from './presenter'
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import Select, { SelectOption } from '@/components/shared/atoms/Select'
import Input from '@/components/shared/atoms/Input'
import TextArea from '@/components/shared/atoms/TextArea'
import BackLink from '@/components/shared/atoms/BackLink'
import { INQUIRY_CONTENTS } from '@/const'
import InquiryValidator, { Fields, FieldErrors } from '@/utils/validators/form/Inquiry/Inquiry'
import { extractTargetFields } from '@/utils/helper'
import { IInquirySeed } from '@/entities/Inquiry'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
}

export default Vue.extend({
  components: {
    FormWrapper,
    FormBlock,
    Select,
    Input,
    TextArea,
    BackLink
  },
  props: {
    categoryId: {
      type: Number,
      default: null
    }
  },
  data(): IData {
    return {
      fields: {
        category: '',
        name: null,
        email: null,
        orderNumber: null,
        content: ''
      },
      enableCheckFlg: {
        category: false,
        name: false,
        email: false,
        orderNumber: false,
        content: false
      }
    }
  },
  computed: {
    presenter(): IPresenter {
      return Presenter({
        profileRepository: this.$profileRepository
      })
    },
    inquiryContents(): SelectOption[] {
      if (!this.categoryId) {
        return Object.keys(INQUIRY_CONTENTS).map(id => ({ value: id, text: INQUIRY_CONTENTS[id].name }))
      }
      return Object.keys(INQUIRY_CONTENTS)
        .filter(id => INQUIRY_CONTENTS[id].categoryIds.includes(this.categoryId))
        .map(id => ({ value: id, text: INQUIRY_CONTENTS[id].name }))
    },
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)

      return InquiryValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      // TODO: 要改善
      const { category, email, name, orderNumber, content } = this.fields
      if (category === null) return false
      if (content === null) return false
      if (!this.presenter.profile) {
        if (email === null) return false
        if (name === null) return false
      }
      if (
        category === 'after_delivery' ||
        category === 'after_payment' ||
        category === 'after_np_payment' ||
        category === 'item_quality' ||
        category === 'after_delivery' ||
        category === 'about_order' ||
        category === 'download' ||
        category === 'tpoint' ||
        category === 'enquete'
      ) {
        if (orderNumber === null) return false
      }
      return true
    },
    canSubmit(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasErrors
    }
  },
  watch: {
    'fields.category': {
      handler(val: IData['fields']['category']) {
        if (!val) return
        this.fields = {
          ...this.fields,
          content: INQUIRY_CONTENTS[val].template
        }
      }
    }
  },
  mounted() {
    if (this.categoryId === 19781031) {
      this.fields.category = 'photo_deletion'
    }
  },
  methods: {
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    enableAllChecks() {
      const { category } = this.fields
      if (!this.presenter.profile) {
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          name: true,
          email: true
        }
      }
      this.enableCheckFlg = {
        ...this.enableCheckFlg,
        category: true,
        content: true
      }
      if (
        category === 'after_delivery' ||
        category === 'after_payment' ||
        category === 'after_np_payment' ||
        category === 'item_quality' ||
        category === 'after_delivery' ||
        category === 'about_order' ||
        category === 'download' ||
        category === 'tpoint' ||
        category === 'enquete'
      ) {
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          orderNumber: true
        }
      }
    },
    submit() {
      this.enableAllChecks()
      if (!this.canSubmit) return
      const { category, content, name, orderNumber, email } = this.fields
      if (typeof category !== 'string') return
      if (typeof content !== 'string') return
      if (!this.presenter.profile) {
        if (typeof name !== 'string') return
        if (typeof email !== 'string') return
      }
      if (
        category === 'after_delivery' ||
        category === 'after_payment' ||
        category === 'after_np_payment' ||
        category === 'item_quality' ||
        category === 'after_delivery' ||
        category === 'about_order' ||
        category === 'download' ||
        category === 'tpoint' ||
        category === 'enquete'
      ) {
        if (typeof orderNumber !== 'string') return
      }

      const data: IInquirySeed = {
        category,
        content,
        name,
        orderNumber,
        email
      }
      this.$emit('success', data)
    }
  }
})
